/**
 * Sodium Club — Judge.me repair + anonymization (product pages only).
 *
 * Part 1: If the Judge.me review widget fails to hydrate, fetch the review
 * data directly and render an accessible fallback (German copy).
 * Part 2: Replace reviewer names with the shared verified-customer label
 * (styling lives in a product-page-scoped style block in theme.liquid).
 */
(function () {
  'use strict';

  var shopDomain = (window.jdgm && window.jdgm.SHOP_DOMAIN) || (window.Shopify && window.Shopify.shop) || '';
  var reviewWidgetScript = 'review_widget.js';
  var ANON_LABEL = '✓ Verifizierter Kunde';

  var escapeHtml = function (value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[character];
    });
  };

  var starHtml = function (rating) {
    var score = Number.parseFloat(rating) || 0;

    return Array.from({ length: 5 }, function (_, index) {
      var state = score >= index + 0.5 ? 'jdgm--on' : 'jdgm--off';
      return '<span class="jdgm-star ' + state + '"></span>';
    }).join('');
  };

  var formatGermanDate = function (value) {
    if (!value) return '';

    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat('de-DE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    }).format(date);
  };

  var reviewCountLabel = function (count) {
    return count === 1 ? '1 Bewertung' : count + ' Bewertungen';
  };

  var reviewDataUrl = function (productId) {
    var params = new URLSearchParams({
      shop_domain: shopDomain,
      platform: 'shopify',
      product_id: String(productId),
      page: '1',
      sort_by: 'created_at',
      sort_dir: 'desc',
      widget_theme: 'standard'
    });

    return 'https://cdn.judge.me/reviews/reviews_for_widget?' + params.toString();
  };

  var loadReviewWidgetModule = function () {
    var cdnBaseUrl = window.jdgm && window.jdgm.CDN_BASE_URL;
    if (!cdnBaseUrl) return;

    var script = document.createElement('script');
    script.type = 'module';
    script.src = cdnBaseUrl + reviewWidgetScript;
    document.head.appendChild(script);
  };

  var renderBadgeFallback = function (productId, reviewData) {
    var rating = Number.parseFloat(reviewData.average_rating) || 0;
    var count = Number(reviewData.number_of_reviews) || 0;

    document.querySelectorAll('.jdgm-preview-badge').forEach(function (badge) {
      if (String(badge.dataset.id) !== String(productId)) return;

      var existingBadge = badge.querySelector('.jdgm-prev-badge');
      if (existingBadge && Number(existingBadge.dataset.numberOfReviews) > 0) return;

      badge.innerHTML =
        '<div class="jdgm-prev-badge" data-average-rating="' + escapeHtml(rating.toFixed(2)) + '" data-number-of-reviews="' + escapeHtml(count) + '" data-number-of-questions="0">' +
          '<span class="jdgm-prev-badge__stars" data-score="' + escapeHtml(rating.toFixed(2)) + '" aria-label="' + escapeHtml(rating.toFixed(2)) + ' von 5 Sternen" role="img">' + starHtml(rating) + '</span>' +
          '<span class="jdgm-prev-badge__text">' + escapeHtml(reviewCountLabel(count)) + '</span>' +
        '</div>';
    });
  };

  var renderReviewFallback = function (widget, reviewData) {
    var rating = Number.parseFloat(reviewData.average_rating) || 0;
    var count = Number(reviewData.number_of_reviews) || 0;
    var reviews = Array.isArray(reviewData.reviews) ? reviewData.reviews.slice(0, 5) : [];

    if (!count || !reviews.length) return;
    if (widget.querySelector('.jdgm-rev, .jm-review-card')) return;
    if (/Basierend auf\s+\d+\s+Bewertungen/i.test(widget.textContent)) return;
    if (/Based on\s+\d+\s+reviews/i.test(widget.textContent)) return;

    widget.innerHTML =
      '<div class="jdgm-rev-widg" data-average-rating="' + escapeHtml(rating.toFixed(2)) + '" data-number-of-reviews="' + escapeHtml(count) + '" data-number-of-questions="0">' +
        '<div class="jdgm-rev-widg__header">' +
          '<h2 class="jdgm-rev-widg__title">Kundenbewertungen</h2>' +
          '<div class="jdgm-rev-widg__summary">' +
            '<div class="jdgm-rev-widg__summary-stars" aria-label="Durchschnittliche Bewertung: ' + escapeHtml(rating.toFixed(2)) + ' von 5 Sternen" role="img">' + starHtml(rating) + '</div>' +
            '<div class="jdgm-rev-widg__summary-text">Basierend auf ' + escapeHtml(reviewCountLabel(count)) + '</div>' +
          '</div>' +
        '</div>' +
        '<div class="jdgm-rev-widg__body">' +
          '<div class="jdgm-rev-widg__reviews">' +
            reviews.map(function (review) {
              return (
                '<div class="jdgm-rev jdgm-divider-top">' +
                  '<div class="jdgm-rev__header">' +
                    '<span class="jdgm-rev__rating" data-score="' + escapeHtml(review.rating || 0) + '" aria-label="Bewertung: ' + escapeHtml(review.rating || 0) + ' von 5 Sternen" role="img">' + starHtml(review.rating || 0) + '</span>' +
                    '<span class="jdgm-rev__author-wrapper">' + escapeHtml(ANON_LABEL) + '</span>' +
                    (review.created_at ? '<span class="jdgm-rev__timestamp">' + escapeHtml(formatGermanDate(review.created_at)) + '</span>' : '') +
                  '</div>' +
                  '<div class="jdgm-rev__content">' +
                    (review.title ? '<b class="jdgm-rev__title">' + escapeHtml(review.title) + '</b>' : '') +
                    '<div class="jdgm-rev__body"><p>' + escapeHtml(review.body || '') + '</p></div>' +
                  '</div>' +
                '</div>'
              );
            }).join('') +
          '</div>' +
        '</div>' +
      '</div>';
  };

  var repairJudgeMeWidget = function () {
    var widget = document.getElementById('judgeme_product_reviews');
    if (!widget || widget.dataset.scJudgemeRepair === 'done') return;

    var productId = widget.dataset.productId || widget.dataset.id;
    if (!productId) return;

    var existingData = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget && window.jdgm.data.reviewWidget[productId];
    if (existingData && Number(existingData.number_of_reviews) > 0) return;

    widget.dataset.scJudgemeRepair = 'done';

    fetch(reviewDataUrl(productId))
      .then(function (response) {
        if (!response.ok) return null;
        return response.json();
      })
      .then(function (reviewData) {
        if (!reviewData || Number(reviewData.number_of_reviews) <= 0) return;

        window.jdgm = window.jdgm || {};
        window.jdgm.data = window.jdgm.data || {};
        window.jdgm.data.reviewWidget = window.jdgm.data.reviewWidget || {};
        window.jdgm.data.reviewWidget[productId] = reviewData;

        widget.dataset.id = productId;
        widget.dataset.productId = productId;
        widget.dataset.widget = 'review';
        widget.dataset.autoInstall = 'false';
        widget.dataset.entryPoint = reviewWidgetScript;
        widget.dataset.entryKey = 'review-widget/main.js';

        renderBadgeFallback(productId, reviewData);
        loadReviewWidgetModule();
        window.setTimeout(function () {
          renderReviewFallback(widget, reviewData);
          anonymizeJudgeMeReviews();
        }, 2500);
      })
      .catch(function (error) {
        console.error(error);
      });
  };

  /* ---- Shared verified-customer label ---- */

  var anonymizeJudgeMeReviews = function () {
    document.querySelectorAll('.jdgm-review-widget').forEach(function (widget) {
      widget.querySelectorAll('.jm-reviewer-info__name, .jdgm-rev__author-wrapper').forEach(function (name) {
        name.dataset.scAnonymized = 'true';
        name.setAttribute('aria-label', ANON_LABEL);
      });

      widget.querySelectorAll('.jm-reviewer-avatar, .jdgm-rev__icon').forEach(function (avatar) {
        avatar.setAttribute('aria-hidden', 'true');
      });

      widget.querySelectorAll('.jdgm-rev__author, .jdgm-rev__location').forEach(function (element) {
        element.setAttribute('aria-hidden', 'true');
      });
    });
  };

  var initAnonymizer = function () {
    anonymizeJudgeMeReviews();

    // Observe only the review widget container; skip everything else.
    var root = document.getElementById('judgeme_product_reviews');
    if (!root || !('MutationObserver' in window)) return;

    var scheduled = false;
    var stableTimer = 0;

    var observer = new MutationObserver(function () {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        anonymizeJudgeMeReviews();
        // Disconnect once the widget content has settled.
        window.clearTimeout(stableTimer);
        stableTimer = window.setTimeout(function () {
          observer.disconnect();
        }, 6000);
      });
    });

    observer.observe(root, { childList: true, subtree: true });
    stableTimer = window.setTimeout(function () {
      observer.disconnect();
    }, 6000);
  };

  var init = function () {
    repairJudgeMeWidget();
    initAnonymizer();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    anonymizeJudgeMeReviews();
  });
})();
